import React, { useState, useEffect } from "react";
import toastr from "toastr";
import { Helmet } from "react-helmet";
import { authFetch } from "../utils/authFetch";

function API() {
  const [APIForm, setAPIForm] = useState({
    product: "",
    name: "",
    url: "",
    username: "",
    password: "",
    optional1: "",
    optional2: "",
    optional3: "",
    optional4: "",
    code: "",
    type: "",
    status: "active",
  });

  const [APIs, setAPIs] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchAPIs = async () => {
    try {
      // const res = await fetch("http://127.0.0.1:6060/api/v1/api/list", {
      //   headers: {
      //     Authorization: `Bearer ${localStorage.getItem("token")}`,
      //   },
      // });
      const res = await authFetch("/api/v1/api/list");
      if (!res) return; // authFetch will redirect if 401

      const data = await res.json();
      if (Array.isArray(data)) setAPIs(data);
      else setAPIs([]);
    } catch (err) {
      showToast("Failed to fetch APIs", "error");
    }
  };

  useEffect(() => {
    fetchAPIs();
  }, []);

  const showToast = (message, type = "success") => {
    toastr.options = {
      closeButton: true,
      progressBar: true,
      positionClass: "toast-top-right",
      timeOut: "3000",
    };

    if (type === "success") toastr.success(message);
    else if (type === "info") toastr.info(message);
    else toastr.error(message);
  };

  const handleCreateOrUpdateAPI = async () => {
    if (!APIForm.name.trim()) {
      showToast("API name is required", "error");
      return;
    }

    setLoading(true);
    const url = editingId
      ? "/api/v1/api/update"
      : "/api/v1/api/create";
    const method = editingId ? "PUT" : "POST";

    try {
      const res = await authFetch(url, {
        method,
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${localStorage.getItem("token")}`,
        // },
        body: JSON.stringify({
          ...APIForm,
          id: editingId,
        }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Something went wrong");

      showToast(editingId ? "API updated" : "API created", editingId ? "info" : "success");

      setAPIForm({
        product: "",
        name: "",
        url: "",
        username: "",
        password: "",
        optional1: "",
        optional2: "",
        optional3: "",
        optional4: "",
        code: "",
        type: "",
        status: "active",
      });
      setEditingId(null);
      fetchAPIs();
      document.querySelector("#exampleModal .btn-close").click();
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (API) => {
    setAPIForm({
      product: API.product || "",
      name: API.name || "",
      url: API.url || "",
      username: API.username || "",
      password: API.password || "",
      optional1: API.optional1 || "",
      optional2: API.optional2 || "",
      optional3: API.optional3 || "",
      optional4: API.optional4 || "",
      code: API.code || "",
      type: API.type || "",
      status: API.status || "active",
    });
    setEditingId(API.id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this API?")) return;

    try {
      const res = await authFetch(`/api/v1/api/delete/${id}`, {
        method: "DELETE",
        // headers: {
        //   Authorization: `Bearer ${localStorage.getItem("token")}`,
        // },
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Delete failed");

      showToast("API deleted", "error");
      fetchAPIs();
    } catch (err) {
      showToast(err.message, "error");
    }
  };

  const handleChange = (e) => {
    setAPIForm({ ...APIForm, [e.target.name]: e.target.value });
  };

  return (
    <>
    <Helmet>
      <title>API Manager | SuvidhaPe</title>
    </Helmet>
    <div className="page-wrapper">
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="card">
            <div className="card-body">
              <div className="card-title d-flex justify-content-between align-items-center">
                <h4 className="mb-0">API Manager</h4>
                <button
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                  onClick={() => {
                    setAPIForm({
                      product: "",
                      name: "",
                      url: "",
                      username: "",
                      password: "",
                      optional1: "",
                      optional2: "",
                      optional3: "",
                      optional4: "",
                      code: "",
                      type: "",
                      status: "active",
                    });
                    setEditingId(null);
                  }}
                >
                  Add
                </button>
              </div>

              {/* Modal */}
              <div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">{editingId ? "Edit API" : "Add API"}</h5>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                      <div className="row">
                      <div className="mb-2 col-lg-6">
                        <label htmlFor="product" className="form-label">Product</label>
                        <input
                          id="product"
                          name="product"
                          placeholder="Product"
                          className="form-control"
                          value={APIForm.product}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="mb-2 col-lg-6">
                        <label htmlFor="apiName" className="form-label">API Name</label>
                        <input
                          id="apiName"
                          name="name"
                          placeholder="API Name"
                          className="form-control"
                          value={APIForm.name}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="mb-2">
                        <label htmlFor="url" className="form-label">URL</label>
                        <input
                          id="url"
                          name="url"
                          placeholder="URL"
                          className="form-control"
                          value={APIForm.url}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="mb-2 col-lg-6">
                        <label htmlFor="username" className="form-label">Username</label>
                        <input
                          id="username"
                          name="username"
                          placeholder="Username"
                          className="form-control"
                          value={APIForm.username}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="mb-2 col-lg-6">
                        <label htmlFor="password" className="form-label">Password</label>
                        <input
                          id="password"
                          name="password"
                          placeholder="Password"
                          className="form-control"
                          type="password"
                          value={APIForm.password}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="mb-2 col-lg-6">
                        <label htmlFor="optional1" className="form-label">Merchant ID</label>
                        <input
                          id="optional1"
                          name="optional1"
                          placeholder="Optional 1"
                          className="form-control"
                          value={APIForm.optional1}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="mb-2 col-lg-6">
                        <label htmlFor="optional2" className="form-label">API Key</label>
                        <input
                          id="optional2"
                          name="optional2"
                          placeholder="Optional 2"
                          className="form-control"
                          value={APIForm.optional2}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="mb-2 col-lg-6">
                        <label htmlFor="optional3" className="form-label">Secret Key</label>
                        <input
                          id="optional3"
                          name="optional3"
                          placeholder="Optional 3"
                          className="form-control"
                          value={APIForm.optional3}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="mb-2 col-lg-6">
                        <label htmlFor="optional4" className="form-label">Client ID</label>
                        <input
                          id="optional4"
                          name="optional4"
                          placeholder="Optional 4"
                          className="form-control"
                          value={APIForm.optional4}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="mb-2 col-lg-6">
                        <label htmlFor="code" className="form-label">Code</label>
                        <input
                          id="code"
                          name="code"
                          placeholder="Code"
                          className="form-control"
                          value={APIForm.code}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="mb-2 col-lg-6">
                        <label htmlFor="type" className="form-label">Type</label>
                        <select
                          id="type"
                          name="type"
                          className="form-control"
                          value={APIForm.type}
                          onChange={handleChange}
                        >
                          <option value="" selected disabled>-- Select Type --</option>
                          <option value="payin">Payin</option>
                          <option value="payout">Payout</option>
                          <option value="pan">Pan</option>
                        </select>
                        {/* <input
                          id="type"
                          name="type"
                          placeholder="Type"
                          className="form-control"
                          value={APIForm.type}
                          onChange={handleChange}
                        /> */}
                      </div>

                      <div className="mb-2">
                        <label htmlFor="status" className="form-label">Status</label>
                        <select
                          id="status"
                          name="status"
                          className="form-control"
                          value={APIForm.status}
                          onChange={handleChange}
                        >
                          <option value="" selected disabled>-- Select Status --</option>
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </select>
                      </div>
                      </div>
                    </div>

                    <div className="modal-footer">
                      <button className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                      <button className="btn btn-primary" onClick={handleCreateOrUpdateAPI} disabled={loading}>
                        {loading ? "Saving..." : editingId ? "Update" : "Save"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Table */}
              <hr />
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th>Name</th>
                      <th>URL</th>
                      <th>Username</th>
                      <th>Code</th>
                      <th>Type</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {APIs.length === 0 && (
                      <tr>
                        <td colSpan="8" className="text-center">No APIs found</td>
                      </tr>
                    )}
                    {APIs.map((API) => (
                      <tr key={API.id}>
                        <td>{API.product}</td>
                        <td>{API.name}</td>
                        <td>{API.url}</td>
                        <td>{API.username}</td>
                        <td>{API.code}</td>
                        <td>{API.type}</td>
                        <td>{API.status}</td>
                        <td>
                          <button className="btn btn-sm btn-info me-2" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => handleEdit(API)}>
                            <span className="bx bx-edit"></span>
                          </button>
                          {/* <button className="btn btn-sm btn-danger" onClick={() => handleDelete(API.id)}>
                            <span className="bx bx-trash"></span>
                          </button> */}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default API;
